module.exports = __webpack_public_path__ + "img/clientix.af9ac8a3.png";